import moment, { Moment } from 'moment';

export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';
export const DEFAULT_DATE_FORMAT_WITH_DASH = 'DD.MM.YYYY';
export const FULL_DATE_FORMAT = 'DD/MM/YYYY HH:mm';
export const FULL_DATE_FORMAT_WITH_SECONDS = 'DD/MM/YYYY HH:mm:ss';
export const MONTH_DAY_FORMAT = 'MMMM DD';
export const US_DATE_TIME_FORMAT = 'MM.DD.YY LT';



export const now = () => moment();

export const formatDateToDefaultFormat = (date: string) => moment(date).format(DEFAULT_DATE_FORMAT);
export const formatDateToDefaultFormatWithDash = (date: string) => moment(date).format(DEFAULT_DATE_FORMAT_WITH_DASH);
export const formatDateToFullFormat = (date: string) => moment(date).format(FULL_DATE_FORMAT);
export const formatDateToFullFormatWithSeconds = (date: string) => moment(date).format(FULL_DATE_FORMAT_WITH_SECONDS);
export const formatDateToMonthDayFormat = (date: string | Moment) => moment(date).format(MONTH_DAY_FORMAT);